import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { DataGridPro, GridActionsCellItem, koKR } from '@mui/x-data-grid-pro';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormGroup,
  FormControlLabel,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
  TableContainer,
  Table,  
  TableCell,
  TableBody,
  TableRow,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import  {
  Clear,
  Delete,
  FilePresent,
  Send,
  Image,
  PictureAsPdf,
  TrafficRounded,
} from '@mui/icons-material';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "../accordion";
import LoadingButton from '@mui/lab/LoadingButton';
import { ReactMultiEmail } from "react-multi-email";
// import "react-multi-email/dist/style.css";
import "./react-multi-email.css";
import { FilePond } from 'react-filepond';
import uploadLabels from '../../FildPondLabel';
import usePrevious from "../hook/usePrevious";
import { gcoreServerUrl } from '../../config';
import {
  FormInputAutoComplete,
  FormInputMultipleSelect,
  FormInputText,
} from "../form";
import {
  CustomNoRowsOverlay,
  // CustomLoadingOverlay,
} from "../datagrid";
import {
  AlertDialog,
  DialogTitleClose,
  PaperComponent,
  ConfirmDialog,
} from "../dialog";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { fontModules, fontFormats, smallStyle, registerFonts } from "../../utils/QuillConfig";
import { findInvalidEmails, formatInvalidEmailLines } from "../../utils/emailUtils";

import * as gclientActions from "../../store/gclient";
import * as userActions from "../../store/user";
import * as g04docuMaterialApprovalActions from "../../store/g04docuMaterialApproval";
import * as errorActions from "../../store/error";
import CustomInputSelect from "../custom/select/CustomInputSelect";
import * as addressBookActions from '../../store/addressBook';
import * as gsendG04docuActions from '../../store/gsendG04docu';

const defaultValues = {
  subject: "",
  html: "",
  recipientLabel: "제출처",
  recipient: "",
  siteLabel: "현장명",
  site: "",
};

const SendMailTypeDialog = ({
  open,
  onClose,
  mailType = "APPROVAL",  // APPROVAL, RELAY
  selectedRow,
  handleClickDownloadAttachFile,
}) => {

  console.log("SendMailTypeDialog selectedRow", selectedRow)

  // 상태 관리
  const [gclients, setGClients] = useState([]);
  const [gclientId, setGClientId] = useState("");
  const [emailOptionsTo, setEmailOptionsTo] = useState([]);
  const [emailOptionsCc, setEmailOptionsCc] = useState([]);
  const [emailOptionsCcInternal, setEmailOptionsCcInternal] = useState([]);
  const [mailTos, setMailTos] = useState([]);
  const [mailCcs, setMailCcs] = useState([]);
  const [mailCcInternals, setMailCcInternals] = useState([]);
  const [mailDirect, setMailDirect] = useState(false);
  const [mailToDirect, setMailToDirect ] = useState([]);
  const [mailCcDirect, setMailCcDirect ] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});
  const [signOption, setSignOption] = useState("NONE");
  const [URLThumbnail, setURLThumbnail] = useState("");
  const [emptyRecipient, setEmptyRecipient] = useState(false);
  const [emptySite, setEmptySite] = useState(false);
  const [addedFiles, setAddedFiles] = useState([]);
  const [checked, setChecked] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [expanded, setExpanded] = useState(false);

  // 컴포넌트 마운트 시 폰트 등록
  useEffect(() => {
    const Quill = ReactQuill.Quill;
    registerFonts(Quill);
  }, []); 

  const { handleSubmit, reset, control, setValue, getValues } = useForm({ defaultValues: defaultValues });

  const sessionUser = useSelector((state) => state.session.sessionUser);
  const rowsAddressBooks = useSelector((state) => state.addressBook.addressBooks);
  const downloadFile = (documentPath) => gclientActions.downloadDirect(documentPath)

  const dispatch = useDispatch();

  const selectAllGClientDirect = () => gclientActions.selectAllDirect()
  const selectAllByGClientDirect = (gclientId) => userActions.selectAllByGClientDirect(gclientId)
  const sendWithLocalFileDirect = (formData) => g04docuMaterialApprovalActions.sendWithLocalFileDirect(formData)
  const relayMailDirect = (formData) => gsendG04docuActions.relayMailDirect(formData)
  const selectAllAddressBook = (searchWord, sort, initConst) => dispatch(addressBookActions.selectAll(searchWord, sort, initConst));


  useEffect(
    async () => {
      if (open) {
        const resGClients = await selectAllGClientDirect();
        setGClients(resGClients);

        // 내부참조
        const { id, email, name } = sessionUser; // sessionUser의 id는 회원사 관리자 id임 (접속한 계정이 회원사 사용자이더라도...)
        const users = await selectAllByGClientDirect(id);
        const emailList = [];
        
        if (email) {
          emailList.push({id: `<${name}> <${email}> <${id}>`, name: `회사대표메일 <${email}>`, group: "거래선" }); // code가 아니라 id임에 유의
        }

        if (users.length > 0) {
          users.forEach(user => {
            const { name, userId, gclient } = user;
            emailList.push({ id: `<${gclient.name}> <${userId}> <${gclient.id}>`, name: `${name} <${userId}>`, group: "거래선" });
          })
        }

        // console.log(emailList)
        if (emailList.length > 0) {
          setEmailOptionsCcInternal(emailList);
        } else {
          setEmailOptionsCcInternal([]);
        }
        
        // 현장명과 제출처 정보 설정 
        if (sessionUser) {
          const { signDocumentPath } = sessionUser;
          if (signDocumentPath) {
            const res = await downloadFile(signDocumentPath);
            const blob = await res.blob(); // res.blob()는 비동기 함수이므로 await 필요
            const url = URL.createObjectURL(blob);
            setURLThumbnail(url);
          }
  
          if (sessionUser["phrases"]) {
            const { supplierLabel, supplier, phrase } = sessionUser["phrases"];
            setValue("supplierLabel", supplierLabel);
            setValue("supplier", supplier);
            setValue("phrase", phrase);
          }
        }

        // 현장명과 제출처 정보 설정 
        if (selectedRow) {
          const { phrases } = selectedRow;
          if (phrases) {
            const { recipient, site } = phrases;
            setValue("recipient", recipient);
            setValue("site", site);
          }
        }

        try {
          // 주소록 조회
          await selectAllAddressBook();
          convertAddressBooks();
          console.log('Address Book Data:', addressOptions);
        } catch (error) {
          console.error('Error initializing mail settings:', error);
        }
      }
    }, [open]
  )

  // 서명 설정 초기화
  useEffect(
    () => {
      if (open) {
        if (selectedRow?.html) {
          setValue("html", selectedRow?.html);
        } else {
          const { sessionUserLoginType } = sessionUser;
          
          const mailSettings = sessionUserLoginType === "USER" ? sessionUser?.user?.mailSettings : sessionUser?.mailSettings;
          //console.log(sessionUserLoginType, mailSettings);
          // 서명 설정 초기화
          if (mailSettings) {
            const footer = mailSettings.footer || {};
            //console.log(footer);
            if (footer.useYn) {
              const initialSignature = footer.message ?? "";
              setValue('html', initialSignature);
              //console.log(getValues('html'));
            }
          }
        }
      }
    }, [sessionUser, open]  
  );

  // 주소록 데이터 변환 함수
  const convertAddressBooks = () => {
    if (rowsAddressBooks && Array.isArray(rowsAddressBooks) && rowsAddressBooks.length > 0) {
      const uniqueAddresses = Array.from(
        new Map(
          rowsAddressBooks.map(address => [
            address.email,
            {
              id: `<${address.company}> <${address.email}> <${address.id}>`,
              name: `${address.name} <${address.email}>`,
              group: "주소록"
            }
          ])
        ).values()
      );
      
      setAddressOptions(uniqueAddresses);
      return uniqueAddresses;
    }

    // rowsAddressBooks가 없거나 비어있는 경우 빈 배열 반환
    setAddressOptions([]);
    return [];
  };

  const handleDialogClose = () => {
    initDialog()
    onClose()
  };

  const initDialog = () => {
    for (const [item, value] of Object.entries(defaultValues)) {
      setValue(item, value);
    }

    // 그외 초기화할 것들은 여기서 초기화
    setGClients([]);
    setGClientId("");
    setEmailOptionsTo([]);
    setEmailOptionsCc([]);
    setEmailOptionsCcInternal([]);
    // 아래 두개의 초기화는 useEffect([gclientId])안에서 이루어짐
    // setMailTos([]);
    // setMailCcs([]);
    setMailCcInternals([]);
    setMailDirect(false);

    setEmptyRecipient(false);
    setEmptySite(false);

    setAddedFiles([]);
    setChecked([]);
    setCheckedAll(false);
  }

  const handleChangeGClient = (e, value) => {
    // console.log(value)
    // if (!value) {
    //   setValue("recipient", "");
    //   return;
    // }

    const { id: gclientId, label } = value;
    setGClientId(gclientId);

    // setValue("recipient", label);
  }

  useEffect(
    () => {
      if (addedFiles.length === 0) {
        setSignOption("NONE");
      }
    }, [addedFiles]
  )

  const handleFileChange = (e) => {
    console.log({ files: e.target.files, addedFiles })
    setAddedFiles(addedFiles.concat([...e.target.files])) // e.target.files는 배열이 아니고 객체임에 주의
    setCheckedAll(false);
    
    document.getElementById('input_files').value = "";
  }

  const handleDeleteCheckedFiles = (e) => {
    const newAddedFiles = addedFiles.filter((file, i) => checked.indexOf(i) > -1 ? false : true);
    setAddedFiles(newAddedFiles);
    setChecked([]);
  }

  const handleDeleteAddedFile = (e, idx) => {
    console.log(addedFiles)
    const newAddedFiles = addedFiles.filter((file, i) => idx !== i)
    setAddedFiles(newAddedFiles);
    setCheckedAll(false);

    const newChecked = checked.map(i => {
      if (i === idx) {
        return null;
      } else if (i >= idx) {
        return i-1;
      } else {
        return i;
      }
    });
    setChecked(newChecked.filter(i => i !== null));
  }

  const handleToggleAll = (e) => {
    console.log(e.target.checked)
    setCheckedAll(e.target.checked);
    if (e.target.checked) {
      const newChecked = addedFiles.map((file, i) => i);
      setChecked(newChecked);
    } else {
      setChecked([]);
    }
  }

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    console.log(newChecked)
    setChecked(newChecked);

    console.log(newChecked.length)
    console.log(addedFiles.length)
    if (newChecked.length === addedFiles.length) {
      setCheckedAll(true);
    } else {
      setCheckedAll(false);
    }
  };

  const prevGClientId = usePrevious(gclientId);

  useEffect(
    async () => {
      if (prevGClientId !== gclientId) {
        setMailTos([]);
        setMailCcs([]);
      }

      // console.log({ prevGClientId, gclientId })
      const selectedGClient = gclients.filter(gclient => gclient.id === gclientId);
      console.log(selectedGClient)
      if (selectedGClient.length === 1) {
        const { id, email, inCharges } = selectedGClient[0];

        const emailList = [];
        if (email) {
          emailList.push({ id: email, name: `회사대표메일 <${email}>` });
        }

        const users = await selectAllByGClientDirect(id);
        if (users.length > 0) {
          users.forEach(user => {
            const { name, userId } = user;
            emailList.push({ id: `${name} <${userId}>`, name: `${name} <${userId}>` });
          })
        }

        // TODO : inCharges 사용하지 않으므로 바꾸어야 함
        if (emailList.length > 0) {
          setEmailOptionsTo(emailList);
          setEmailOptionsCc(emailList);
        } else {
          setEmailOptionsTo([]);
          setEmailOptionsCc([]);
        }
      }
    }, [gclientId]
  )
  
  // console.log(objValues);
  const onSubmit = async ({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site }) => {
    // console.log({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site, signOption });
    // return;

    if (addedFiles.length > 0 && signOption === 'CERTIFIED_TRUE_COPY_AND_SIGN') {
      if (!recipient) {
        setEmptyRecipient(true);
      }

      if (!site) {
        setEmptySite(true);
      }

      if (!recipient || !site) {
        setAlertInfo({
          titleAlert: "안내",
          messageAlert: `제출처나 현장명을 모두 입력해주세요.`,
          open: true,
        });
        return;
      }
    }

    
    await sendMail({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site });
  }

  const sendMail = async ({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site }, sendReplace) => {
    // console.log({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site, sendReplace })
    // return;

    // 메일 보내기 전 유효성 체크, TODO : 더 체크할게 있는지 검토할 것
    const mailToArr = mailDirect ? mailToDirect.map(item => ({ id: item, name: item })) : (mailTo ? mailTo : []);
    console.log(mailToArr)
    if (mailToArr) {
      if (mailToArr.length <= 0) {
        setAlertInfo({
          titleAlert: "안내",
          messageAlert: `받는 사람을 입력해주세요.`,
          open: true,
        });
        return;
      }
    }

    const mailCcArr = mailDirect
      ? (mailCcDirect || []).map(item => ({ id: item, name: item }))
      : (mailCc ? mailCc : []);
    const invalidEmails = [
      ...findInvalidEmails(mailToArr),
      ...findInvalidEmails(mailCcArr),
      ...findInvalidEmails(mailCcInternal || []),
    ];
    if (invalidEmails.length > 0) {
      setAlertInfo({
        titleAlert: "안내",
        messageAlert: (
          <>
            <div>메일 주소 형식이 올바르지 않습니다.</div>
            <div style={{ marginTop: '8px', whiteSpace: 'pre-line' }}>
              {formatInvalidEmailLines(invalidEmails).join('\n')}
            </div>
          </>
        ),
        open: true,
      });
      return;
    }

    try {
      // console.log(addedFiles)
      
      setLoading(true);

      const addedFileNames = [];
      const formData = new FormData();

      // if (sendReplace) {
        formData.append("sendReplace", sendReplace);
      // }

      // attachments
      const attachmentsOrg = selectedRow?.attachments;
      const attachmentsData = attachmentsOrg.map(attachment => ({
        filename: attachment.filename,
        path: attachment.path,
      }));

      // phrases 변경
      const phrasesOrg = selectedRow?.phrases;
      const phrasesData = {
        supplier: sessionUser["phrases"]?.supplier,
        phrase: sessionUser["phrases"]?.phrase,   // "본 문서는 원본과 같음을 확인하며, 상기 현장 외에 사용을 금합니다."
        recipient: phrasesOrg?.recipient,         // "제출처"
        site: phrasesOrg?.site,                   // "현장명"
      }

      // mailToArr에서 첫 번째 거래선 찾기
      const firstMailTo = mailToArr.find(mail => mail.group === "거래선"|| mail.group === "주소록");
      const firstGClientName = firstMailTo?.id.match(/<([^>]+)>/)?.[1] || '';

      formData.append("mailData", JSON.stringify({
        gclientTo: firstMailTo ? { name: firstGClientName } : {}, 
        options: { signOption : addedFiles.length > 0 ? signOption : "NONE" },
        html,
        subject,
        mailTo: mailToArr,
        mailCc: mailDirect ? mailCcDirect.map(item => ({ id: item, name: item })) : (mailCc ? mailCc : []),
        mailCcInternal,
        attachments: attachmentsData,
        phrases: phrasesData,
      }));
      
      // addedFiles는 배열이 아니고 객체이므로 아래와 같이 배열로 변환
      console.log(addedFiles)
      // if (addedFiles && !objectEmptyCheck(addedFiles) && Array.isArray([...addedFiles])) {
      //   [...addedFiles].forEach((file) => { // formData.append('addedFiles', addedFiles); 이렇게 넘기면 안됨
      //     formData.append("addedFiles", file);
      //     addedFileNames.push(file.name)
      //   });
      // }
      
      addedFiles.forEach((file) => { // formData.append('addedFiles', addedFiles); 이렇게 넘기면 안됨
        formData.append("addedFiles", file);
        addedFileNames.push(file.name)
      });
      
      // console.log(addedFileNames);
      formData.append("addedFileNames", JSON.stringify(addedFileNames));
      let res = null;
      if (mailType === "APPROVAL") {
        res = await sendWithLocalFileDirect(formData);
      } 
      // 메일 전달
      else if (mailType === "RELAY") {
        res = await relayMailDirect(formData);
      }
      
      console.log("mail send result => ", res)
      
      if (res) {
        if (res.gsendG04docu) {
          setLoading(false);
          if (res.gsendG04docu?.id) { 
            setAlertInfo({
              titleAlert: "안내",
              messageAlert: `메일이 전송되었습니다.`,
              open: true,
            });

            setTimeout(() => handleDialogClose(false), 500);
          }
        } else {
          console.log(res)
          dispatch(errorActions.occurError({ response: null, serverResponse: res })); // 오류 처리 방식 4
        }
      } else {
        console.log('메일 전송 실패')
      }
      
      setLoading(false);
    } catch (e) {
      console.log(e)
      setLoading(false);
      const message = e?.message || e?.serverResponse?.message;
      if (message) {
        setAlertInfo({
          titleAlert: "안내",
          messageAlert: message,
          open: true,
        });
      }
    }
  }
  
  const sendMailByGClient = async () => {
    const mailTo = getValues("mailTo");
    const mailCc = getValues("mailCc");
    const mailCcInternal = getValues("mailCcInternal");
    const subject = getValues("subject");
    const html = getValues("html");
    const recipient = getValues("recipient");
    const site = getValues("site");
    console.log({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site })

    await sendMail({ mailTo, mailCc, mailCcInternal, subject, html, recipient, site }, true/*sendReplace*/);
  }

  const handleChangeSignOption = (e) => {
    const { value } = e.target;
    setSignOption(value);
  }

  return (
    <>
    <Dialog
        open={open}
        onClose={handleDialogClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitleClose
          id="draggable-dialog-title"
          onClose={handleDialogClose}
          style={{ cursor: 'move' }}
        >
          {"메일 전송"}
        </DialogTitleClose>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <CardHeader
                  titleTypographyProps={{ variant: 'subtitle1' }}
                  title={"메일 쓰기"}
                  sx={{ bgcolor: "#eaeaea" }}
                  // action={
                  //   <FormGroup>
                  //     <FormControlLabel control={<Checkbox onChange={handleChangeDirect}/>} label="직접쓰기" />
                  //   </FormGroup>
                  // }
                />
                <CardContent>
                  <Grid container spacing={2}>
                    {
                      mailDirect === false ? (
                        <>
                          <Grid item xs={12}>
                            <FormInputAutoComplete
                              control={control}
                              label={"거래선명"}
                              options={gclients.map(gclient => ({ label: gclient.name, id: gclient.id }))}
                              setValue={setValue}
                              onCustomChange={handleChangeGClient}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <CustomInputSelect
                              defaultOptions={emailOptionsTo} // 기존 emailOptionsTo를 defaultOptions로 사용
                              addressOptions={addressOptions}
                              label="받는 사람"
                              placeholder="이메일 선택 또는 직접 입력하세요."
                              onChange={(value) => {
                                setMailTos(value);
                                setValue('mailTo', value); // react-hook-form 값 설정
                              }}
                              width="100%" // Grid 시스템 사용시 100%로 설정
                              size="small" // MUI Grid와 일관성을 위해 small 사이즈 사용
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <CustomInputSelect
                              defaultOptions={emailOptionsTo} // 기존 emailOptionsTo를 defaultOptions로 사용
                              addressOptions={addressOptions}
                              label="참조"
                              placeholder="이메일 선택 또는 직접 입력하세요."
                              onChange={(value) => {
                                setMailCcs(value);
                                setValue('mailCc', value); // react-hook-form 값 설정
                              }}
                              width="100%" // Grid 시스템 사용시 100%로 설정
                              size="small" // MUI Grid와 일관성을 위해 small 사이즈 사용
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <FormInputMultipleSelect
                              id="multiple-mail-cc-internal-select"
                              name="mailCcInternal"
                              label={"내부참조"}
                              control={control}
                              setValue={setValue}
                              dynamicItemsBasic={mailCcInternals}
                              onChangeItem={(value) => setMailCcInternals(value.map(i => ({ ...JSON.parse(i) })))}
                              options={emailOptionsCcInternal}
                              chipSize={"small"}
                            />
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <ReactMultiEmail
                              placeholder="받는 사람"
                              emails={mailToDirect}
                              onChange={(_emails) => setMailToDirect(_emails)}
                              getLabel={( email, index, removeEmail ) => {
                                return (<div data-tag key={index}>
                                  {email}
                                  <span data-tag-handle onClick={() => removeEmail(index)}>×</span>
                                </div>);
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <ReactMultiEmail
                              placeholder="참조"
                              emails={mailCcDirect}
                              onChange={(_emails) => setMailCcDirect(_emails)}
                              getLabel={( email, index, removeEmail) => {
                                return (<div data-tag key={index}>
                                  {email}
                                  <span data-tag-handle onClick={() => removeEmail(index)}>×</span>
                                </div>);
                              }}
                            />
                          </Grid>
                        </>
                      )
                    }
                    <Grid item xs={12}>
                      <FormInputText
                        name={"subject"}
                        control={control}
                        label={"제목"}
                      />
                    </Grid>
                    <Grid item xs={12}>
                    <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
                      <AccordionSummary aria-controls="basic-content" id="basic-header">
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography variant="body" component="div">{`첨부파일 (${selectedRow?.attachments && selectedRow?.attachments?.length ? selectedRow?.attachments?.length : 0})`}</Typography>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        {
                          selectedRow?.attachments && selectedRow?.attachments?.length > 0 && selectedRow?.attachments?.map(file => {
                            const { filename, path } = file;
                            const pos = filename.lastIndexOf(".");
                            let ext = "";
                            if (pos > -1) {
                              ext = filename.substring(pos+1);
                            }

                            return (
                              <ListItem disablePadding>
                                <Tooltip title={"다운로드"}>
                                <ListItemButton onClick={(e) => handleClickDownloadAttachFile(e, path)}>
                                  <ListItemIcon>
                                    { ext.toLowerCase() === 'pdf' ? <PictureAsPdf /> : <Image /> }
                                  </ListItemIcon>
                                  <ListItemText primary={filename} />
                                </ListItemButton>
                                </Tooltip>
                              </ListItem>
                            )
                          })
                        }     
                      </AccordionDetails>
                    </Accordion>
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="flex-end" sx={{ color: 'white', fontSize: '0.9em' }}>
                      <label
                        id="input_files_label"
                        htmlFor={"input_files"}
                        /*ref={uploadFilesBoxRef}*/
                        style={{ cursor: 'pointer', borderRadius: '4px', backgroundColor: '#1976D2' }}
                      >
                        <div className="input-label" style={{ padding: '8px' }}>
                          {"서류 추가"}
                        </div>
                      </label>
                      <input hidden type="file" multiple accept="image/*,.pdf" id={"input_files"}/* ref={inputFilesRef}*/onChange={handleFileChange} />
                    </Grid>
                    
                    {
                      addedFiles.length > 0 && (
                        <Grid item xs={12}>
                          <List dense={true}>
                            <ListItem
                              disablePadding>
                              <ListItemButton>
                                <Checkbox
                                  size="small"
                                  checked={checkedAll}
                                  onChange={handleToggleAll}
                                />
                                <Button size="small" disabled={checked.length > 0 ? false : TrafficRounded} onClick={(e) => handleDeleteCheckedFiles(e)}>
                                  {"삭제"}
                                </Button>
                              </ListItemButton>
                            </ListItem>
                            {
                              addedFiles.map((file, idx) => {
                                // console.log(file)
                                const { name } = file;
                                const pos = name.lastIndexOf(".");
                                let ext = "";
                                if (pos > -1) {
                                  ext = name.substring(pos+1);
                                }
    
                                return (
                                  <ListItem
                                    secondaryAction={
                                      <IconButton size="small" onClick={(e) => handleDeleteAddedFile(e, idx)}>
                                        <Clear  sx={{ width: 14, height: 14 }} />
                                      </IconButton>
                                    }
                                    disablePadding>
                                    <ListItemButton>
                                      <Checkbox
                                        onChange={handleToggle(idx)}
                                        checked={checked.indexOf(idx) !== -1}
                                        inputProps={{ 'aria-labelledby': idx }}
                                        size="small"
                                      />
                                      <ListItemIcon>
                                        { ext.toLowerCase() === 'pdf' ? <PictureAsPdf /> : <Image /> }
                                      </ListItemIcon>
                                      <ListItemText primary={name} />
                                    </ListItemButton>
                                  </ListItem>
                                )
                              })
                            }
                          </List>
                        </Grid>
                      )
                    }
                    {
                      addedFiles.length > 0 && (
                        <>
                          <Grid item xs={12}>
                            {"원본대조필"}
                            {/* <span style={{ fontWeight: 'bold', color: '#1976d2' }}>{"원본대조필과 인감, 현장정보"}</span>{" 를 "}
                            <span style={{ fontWeight: 'bold', color: '#1976d2' }}>{"추가첨부 서류"}</span>{"에 날인합니다."} */}
                          </Grid>
                          <Grid item xs={12}>
                            <ToggleButtonGroup
                              color="primary"
                              value={signOption}
                              exclusive
                              // size="small"
                              onChange={handleChangeSignOption}
                            >
                              <ToggleButton value="CERTIFIED_TRUE_COPY_AND_SIGN">{"원본대조필 인쇄"}</ToggleButton>
                              <ToggleButton value="NONE">{"원본대조필 인쇄안함"}</ToggleButton>
                            </ToggleButtonGroup>  
                          </Grid>
                          <Grid item xs={12} sx={{ display: signOption === 'NONE' ? 'none' : "" }}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Grid container>
                                <Grid xs={12} display="flex" justifyContent={"center"} alignItems="center">
                                  <TableContainer>
                                    <Table aria-label="날일정보" sx={{ width: 400 }} size="small">
                                      <TableBody>
                                        <TableRow>
                                          <TableCell colspan={2} sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, width: '90%', fontSize: '20px', color: '#664AA0' }}>
                                            <Box display="flex" justifyContent="center" alignItems="center">
                                              {"원본대조필 (인)"}
                                            </Box>
                                          </TableCell>
                                          <TableCell sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, color: '#664AA0', p: 0 }}>
                                            {
                                              URLThumbnail && (<Box sx={{ width: 60, height: 60 }} display="flex" justifyContent={"center"} alignItems={"center"}>
                                                <img src={URLThumbnail} alt="이미지 미리보기" style={{ maxWidth: '58px' }} />
                                              </Box>)
                                            }
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, color: '#664AA0', width: '30%' }}>
                                            <Grid container>
                                              <Grid item xs={10}>
                                                <FormInputText
                                                  autoComplete="supplierLabel"
                                                  name={"supplierLabel"}
                                                  control={control}
                                                  required
                                                  fullWidth
                                                  errorStyle={{ message: false, border: true }}
                                                  variant="standard"
                                                  InputProps={{
                                                    disableUnderline: true,
                                                    readOnly: true,
                                                  }}
                                                  inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                {" : "}
                                              </Grid>
                                            </Grid>
                                          </TableCell>
                                          <TableCell colSpan={2} sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, color: '#664AA0' }}>
                                            <FormInputText
                                              autoComplete="supplier"
                                              name={"supplier"}
                                              control={control}
                                              required
                                              fullWidth
                                              errorStyle={{ message: false, border: true }}
                                              variant="standard"
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                              InputProps={{
                                                disableUnderline: true,
                                                readOnly: true,
                                              }}
                                            />
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, width: '30%', fontSize: '14px', color: '#664AA0' }}>
                                            <Grid container>
                                              <Grid item xs={10}>
                                                <FormInputText
                                                  name={"recipientLabel"}
                                                  control={control}
                                                  variant="standard"
                                                  inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                                  InputProps={{
                                                    disableUnderline: true,
                                                    readOnly: true,
                                                  }}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                {" : "}
                                              </Grid>
                                            </Grid>
                                          </TableCell>
                                          <TableCell colSpan={2} sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, fontSize: '14px', color: '#664AA0' }}>
                                            <FormInputText
                                              name={"recipient"}
                                              control={control}
                                              variant="standard"
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                              error={emptyRecipient}
                                              errorStyle={{ message: false, border: true }}
                                              // onChange={handleChangeRecipient}
                                              InputProps={{
                                                readOnly: getValues("recipient"),
                                                disableUnderline: getValues("recipient")
                                              }}
                                            />
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell sx={{ borderTop: 1, borderLeft: 1, borderBottom: 1, width: '30%', fontSize: '14px', color: '#664AA0' }}>
                                            <Grid container>
                                              <Grid item xs={10}>
                                                <FormInputText
                                                  name={"siteLabel"}
                                                  control={control}
                                                  variant="standard"
                                                  inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                                  InputProps={{
                                                    disableUnderline: true,
                                                    readOnly: true,
                                                  }}
                                                />
                                              </Grid>
                                              <Grid item xs={2}>
                                                {" : "}
                                              </Grid>
                                            </Grid>
                                          </TableCell>
                                          <TableCell colSpan={2} sx={{ borderTop: 1, borderRight: 1, borderBottom: 1, fontSize: '14px', color: '#664AA0' }}>
                                            <FormInputText
                                              name={"site"}
                                              control={control}
                                              variant="standard"
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                              error={emptySite}
                                              errorStyle={{ message: false, border: true }}
                                              // onChange={handleChangeSite}
                                              InputProps={{
                                                readOnly: getValues("site"),
                                                disableUnderline: getValues("site")
                                              }}
                                            />
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell colSpan={3} sx={{ border: 1, borderColor: '#664AA0' }}>
                                            <FormInputText
                                              name={"phrase"}
                                              control={control}
                                              // label={"문구"}
                                              // fullWidth
                                              // multiline
                                              // maxRows={5}
                                              // onChange={handleChangePhrase}
                                              variant="standard"
                                              InputProps={{
                                                disableUnderline: true,
                                                readOnly: true,
                                              }}
                                              inputProps={{ style: { fontSize: 14, color: '#664AA0' } }}
                                            />
                                          </TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        </>
                      )
                    }
                    <Grid item xs={12}>
                      <Box sx={smallStyle}>
                        <ReactQuill
                          value={getValues('html')}
                          onChange={(content) => {
                            setValue('html', content);
                          }}
                          modules={fontModules}
                          formats={fontFormats}
                          placeholder="메시지를 입력하세요..."
                          theme="snow"
                          style={{ 
                            height: '150px',      // 전체 높이
                            marginBottom: '20px'  // 하단 마진
                          }}
                          
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pt: 2, pb: 2, pr: 3 }}>
          <LoadingButton
            variant="contained"
            onClick={handleSubmit(onSubmit)}
            // onClick={files.length > 0 ? () => sendMail() : () => handleSubmit(onSubmit)()}
            loading={loading}
          >
            {"보내기"}
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <AlertDialog
        alertInfo={alertInfo}
        setAlertInfo={setAlertInfo}
      />
      <ConfirmDialog
        removeId={""}
        title={"안내"}
        open={confirmOpen}
        setOpen={setConfirmOpen}
        onConfirm={sendMailByGClient}
        onCancel={() => {}}
        maxWidth="sm"
      >
        <>
          <span>{`메일설정이 되어 있지 않습니다. 내정보에서 메일설정을 해주세요.`}</span><br /><br />
          <span>{`나중에 설정하고 지금은 아래 관리자 메일로 보내시겠습니까?`}</span><br />
          <Box sx={{ solid: 1, borderRadius: 1, bgcolor: '#eee', color: '#1976d2', p: 2, mt: 1, fontSize: '1em' }}>
            <span>{`보내는 사람 ${sessionUser.email}`}</span><br />
            <span>{`참조 ${sessionUser && sessionUser.user ? sessionUser.user.userId : ""}`}</span>
          </Box>
        </>
        {/* {`"${params && params.row && params.row.name || ""}(아이디 : ${params && params.id  || ""})"를 삭제하시겠습니까?`} */}
      </ConfirmDialog>
    </>
  )
};

export default SendMailTypeDialog;